import { render, staticRenderFns } from "./NonCompliantProductModalDetailComponent.vue?vue&type=template&id=01741fb2"
import script from "./NonCompliantProductModalDetailComponent.vue?vue&type=script&lang=js"
export * from "./NonCompliantProductModalDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports